import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import i18next from 'i18next';
import FormQuestions from './components/FormQuestions';
import swal from 'sweetalert';
import { postApi } from './api/services';
import { serviceDown } from './utils/UtilityFunctions';
import MainLoader from './components/MainLoader';


const PatientRegistration = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [formValues, setFormValues] = useState({
    phone: '',
    f_name: '',
    l_name: '',
    age: '',
    date: '',
    gender: '',
    passport: ''
  });

  const formQuestions = [
    {
      title: "First Name",
      type: "text",
      placeholder: "Enter first name",
      commonIdentifier: "f_name",
      questionId: 1
    },
    {
      title: "Last Name",
      type: "text",
      placeholder: "Enter last name",
      commonIdentifier: "l_name",
      questionId: 2
    },
    // {
    //   title: "Age",
    //   type: "number",
    //   placeholder: "Enter age",
    //   commonIdentifier: "age",
    //   questionId: 4
    // },
    {
      title: "Year of Birth",
      type: "date",
      placeholder: "Select year",
      commonIdentifier: "date",
      questionId: 3
    },
    {
      title: "Gender",
      type: "dropdown",
      placeholder: "Select gender",
      commonIdentifier: "gender",
      optionMap: [
        "Male",
        "Female"
      ],
      questionId: 4
    },
    // {
    //   title: "Passport ID",
    //   type: "alphanumeric",
    //   placeholder: "Enter passport ID",
    //   commonIdentifier: "passport",
    //   questionId: 5
    // },
    // {
    //   title: "Mobile Number",
    //   type: "number",
    //   placeholder: "Enter mobile number",
    //   commonIdentifier: "phone",
    //   questionId: 6
    // },
    // {
    //   title: "Email",
    //   type: "email",
    //   placeholder: "Enter your email",
    //   commonIdentifier: "email",
    //   questionId: 7
    // }
  ];

  const handleFormValues = (value, identifier) => {
    setFormValues((prev) => {
      const updated = { ...prev };

      switch (identifier) {
        case "phone":
          updated.phone = value;
          break;
        case "f_name":
          updated.f_name = value;
          break;
        case "l_name":
          updated.l_name = value;
          break;
        // case "age":
        //   updated.age = value;
        //   break;
        case "date":
          updated.date = value;
          break;
        case "gender":
          updated.gender = value;
          break;
        case "passport":
          updated.passport = value;
          break;
        default:
          break;
      }
      return updated;
    });
  }

  const handleSubmit = async () => {
    if(
      // formValues.phone === '' || 
      formValues.f_name === '' ||
      formValues.l_name === '' || 
      // formValues.age === '' ||
      formValues.date === '' || 
      formValues.gender === '' 
      // formValues.passport === ''
    ) {
      swal({
        title: i18next.t("Please fill all the fields"),
        icon: "warning",
      })
    } else if(formValues.phone.startsWith('0')) {
      swal({
        title: i18next.t("Phone number should not start with 0"),
        icon: "warning",
      })
    } else {
      setIsLoading(true)
      let docDetails = JSON.parse(localStorage.getItem('doctorobj'))
      let params = {
        // phone_number: formValues.phone,
        year_of_birth: formValues.date,
        gender: formValues.gender,
        first_name: formValues.f_name,
        last_name: formValues.l_name,
        doctor_referral_code: null,
        nurse_referral_code: docDetails.nurse_id,
        clinic_referral_code: docDetails.clinic_id
      }
      console.log("add_patient params", params);
      try {
        let res = await postApi('add_patient', params)
        console.log("add_patient res", res);
        if(res.error) {
          setIsLoading(false)
          serviceDown('/homepage')
        } else {
          setIsLoading(false)
          navigate('/taketest', {state:{ goTo: 'taketest', user_obj: res.user_obj}});
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false)
        serviceDown('/homepage')        
      }     
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='patientregpage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate(-1, { state: { goTo: location?.state?.from }})}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
            <Typography variant="h6" className="title">{i18next.t("Patient Registration")}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid>
        </Grid>
        <div className='patientregpage-questions-container'>
          <div className='patientregquescontainer'>
            {formQuestions?.length > 0 && formQuestions.map((ele) => {
              return (
                <Grid item xs={12} className='d-flex justify-content-center align-items-center patientregGrid'>
                  <FormQuestions 
                    element={ele} 
                    handleFormValues={handleFormValues}
                    formValues={formValues}
                  />
                </Grid>
              )
            })}
          </div>
          <Button className='submitButton commonButton mt-20px' variant="contained" onClick={handleSubmit}>
            {i18next.t("Register")}
          </Button>
        </div>
      </div>
    </>
  )
}

export default PatientRegistration